var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-upload',{ref:"uploadFileXls",attrs:{"limit":1,"action":"","http-request":_vm.uploadFile,"show-file-list":false,"auto-upload":true,"file-list":_vm.fileList,"accept":".xls, .xlsx"}},[_c('el-button',{attrs:{"loading":_vm.loading}},[_vm._v("导入评论")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }